/* 产引入encryptlong实现数据RSA加密 */
import JSEncrypt from 'jsencrypt' ; // encryptlong是基于jsencrypt扩展的长文本分段加解密功能。

// 公钥key
const publicKey = process.env.PUBLICKEY

export default {
  // /* 加密 */
  // encrypt(data) {
  //   var encryptor = new JSEncrypt()
  //   encryptor.setPublicKey(publicKey)
  //   // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
  //   const result = encryptor.encryptLong(data)
  //   return result
  // },
  // /* 解密 - PRIVATE_KEY - 验证 */
  // decrypt(data) {
  //   var encryptor = new JSEncrypt()
  //   // encryptor.setPrivateKey(publicKey)
  //   encryptor.setPublicKey(publicKey)
  //   var result = encryptor.decryptLong(data)
  //   return result
  // }
  encrypt(data) {
    let jse = new JSEncrypt();
    let publicString = publicKey;
    jse.setPublicKey(publicString);
    // 加密内容
    let encrypted = jse.encrypt(data);
    return encrypted;
  },
  decrypt(data) {
    let jse = new JSEncrypt();
    //公钥
    let privateKey = publicKey;
    jse.setPublicKey(privateKey);
    // 加密内容
    let decrypt = jse.decrypt(data);
    return decrypt;
  },
};



// WEBPACK FOOTER //
// ./src/utils/rsa.js